function openCart() {
  $("body").addClass("body-overflow-hidden");
  $("#cart-preview").addClass("visible");
  setTimeout(function(){$("#cart-preview").removeClass("visible"); }, 3000);
}
function quantityCounter() {
  $(document).on("click", "#q_up", function() {
    var C = $(this).attr("data-id"),
        S = parseInt($(this).siblings(".quantity-cart-"+C).val()) + 1;
    $(this).attr("data-quantity", S);
    $(this).siblings(".quantity-cart-"+C).val(S);

  }), $(document).on("click", "#q_down[data-quantity!='0']", function() {
    var C = $(this).attr("data-id"),
        S = parseInt($(this).siblings(".quantity-cart-" + C).val());
    0 < S && $(this).attr("data-quantity", (S - 1));
    0 < S && $(this).siblings(".quantity-cart-" + C).val(S - 1);

  })
}
function quantityCounterColl() {
  $(document).on("click", "#add-cart .q_up", function() {
    var C = $(this).attr("data-id"),
        S = parseInt($(this).siblings(".quantity-cart-"+C).val()) + 1;
    $(this).attr("data-quantity", S);
    $(this).siblings(".quantity-cart-"+C).val(S);
    openCart();

  }), $(document).on("click", '#add-cart .q_down', function() {
    var C = $(this).attr("data-id"),
        S = parseInt($(this).siblings(".quantity-cart-" + C).val());
    0 < S && $(this).attr("data-quantity", (S - 1));
    0 < S && $(this).siblings(".quantity-cart-" + C).val(S - 1);
    openCart();
  })
}

function convertToRupiah(angka){
  var rupiah = '';
  angka = angka.toString();
  angka =  angka.substring(0, angka.length-2);
  var angkarev = angka.toString().split('').reverse().join('');
  for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
  return 'Rp '+rupiah.split('',rupiah.length-1).reverse().join('');
}

function editCart() {
  $(document).on("click", ".change-cart:not(.disabled)", function(y) {
    y.preventDefault();
    var C = $(this),
        newQuantity = parseInt(C.attr("data-quantity")),
        S = C.attr("data-id"),
        parent = $("#item-"+S);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity="+newQuantity+"&id=" + S,
      dataType: "json",
      beforeSend: function() {
        // cart operation
        parent.addClass("loading");
      },
      success: function(E) {
        // Update cart number
        var B = $('.total_count');
        B.text(E.item_count);
        B.attr('title', E.item_count);


        updateDrawerNonLangganan();
        updateTotalCart()
        //updateDrawerLangganan();
        //updateFloatingCart(E.total_price);

        $('input.quantity-cart-'+S).val(newQuantity);
      },
      error: function(I, P) {
        console.log("Error occured while editing cart");
      }
    })
  })
}

// BELANJA
function belanjaAddToCart() {
  $(document).on("click", ".add-cart:not(.disabled)", function() {
    var y = $(this),
        S = y.closest("form"),
        id = $(this).attr('data-id')
    return $.ajax({
      type: "POST",
      url: "/cart/add.js",
      async: !0,
      cache: !1,
      data: S.serialize(),
      dataType: "json",
      complete: function() {
        $('input.quantity-cart-'+id).val('1');
      },
      error: function(T) {
        updateCart(T, !1)
      },
      success: function(T) {
        // Add only return one single json
        var B = $('.total_count');
        var count = parseInt(B.attr('title')) + 1;
        B.text(count);
        B.attr('title', count);
        updateDrawerNonLangganan();
        updateCart(T, !0);
        openCart()
        updateTotalCart()
      }
    }).done(function() {}), !1
  })
}

function updateCart(y, C) {
  if (!0 == C) $.ajax({
    url: "/search?view=cart&q=" + y.handle + "_" + y.variant_id + "_" + y.quantity + "_" + y.price,
    beforeSend: function() {},
    success: function(T) {
      //var P = "#shopify-section-floating-bottom";
      //$(P).html($(T).filter(P).html());
      //$(P).fadeIn().delay(5000).fadeOut();
    },
    error: function(T) {
      console.log(T)
    }
  })
  else {
    var S = $.parseJSON(y.responseText);
    $.ajax({
      url: "/search?view=cart_error&q=" + S.description,
      beforeSend: function() {},
      success: function(T) {
        var I = "div#cart_error_popup";
        $(I).html($(T).filter(I).html())
      },
      error: function(T) {
        console.log(T)
      }
    }).done(function() {
      var T = i = $.parseJSON(y.responseText),
          I = T.message + ": " + T.description;
      $.notify({
        message: I,
        target: "_blank"
      }, {
        type: "info",
        showProgressbar: !0,
        z_index: 2031,
        mouse_over: "pause",
        placement: {
          from: "top",
          align: window.rtl ? "left" : "right"
        }
      })
    })
  }
}

// AJAX DRAWER
function drawerEditCart() {
  $(document).on("click", ".drawer-cart[data-quantity!='0']", function(y) {
    y.preventDefault();
    var C = $(this),
        newQuantity = parseInt(C.attr("data-quantity")),
        S = C.attr("data-id"),
        parent = $("#item-"+S);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity="+newQuantity+"&id=" + S,
      dataType: "json",
      beforeSend: function() {
        // cart operation
        parent.addClass("loading");
      },
      success: function(E) {
        // Update cart number
        var B = $('.total_count');
        B.text(E.item_count);
        B.attr('title', E.item_count);
        $('input.quantity-cart-'+S).val(newQuantity);
        //updateDrawerLangganan();
        updateDrawerNonLangganan();
        updateTotalCart()
        //updateFloatingCart(E.total_price);

        // Updating other element in the page.
        // quantity-cart-29291365269601
        // quantity-cart-29291365269601

      },
      error: function(I) {
        console.log(I);
      }
    })
  })
}

function editCartPage() {
  $(document).on("click", ".cartPage[data-quantity!='0']", function(y) {
    console.log('sdsd')
    y.preventDefault();
    var C = $(this),
        newQuantity = parseInt(C.attr("data-quantity")),
        S = C.attr("data-id"),
        parent = $("#item-"+S);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity="+newQuantity+"&id=" + S,
      dataType: "json",
      beforeSend: function() {
        // cart operation
        parent.addClass("loading");
      },
      success: function(E) {
        // Update cart number
        var B = $('.total_count');
        B.text(E.item_count);
        B.attr('title', E.item_count);
        $('input.quantity-cart-'+S).val(newQuantity);
        updateCartPage();
        updateTotalCart()

      },
      error: function(I) {
        console.log(I);
      }
    })
  })
}

// CART
function cartCheckout(){
  // Function only process date and note from non-langganan product
  $(document).on("click", ".checkout-process:not(.disabled)", function(y) {
    y.preventDefault();
    var C = $(this);
    var S = $("form#cartAttribute");
    return $.ajax({
      type: "POST",
      url: "/cart/update.js",
      async: !0,
      cache: !1,
      data: S.serialize(),
      dataType: "json",
      beforeSend: function() {
        C.text('Sedang memproses..')
      },
      complete: function() {},
      error: function(T) {
        console.log(T);
      },
      success: function(T) {
        var urlNext = C.attr('href');
        window.location.replace(urlNext);
      }
    }).done(function() {}), !1
  });
}

function updateDrawerNonLangganan(){
  var drawer = $("#ajax-drawer");
  $.ajax({
    url: "/search?view=ajax-drawer",
    beforeSend: function() {drawer.addClass('loading')},
    success: function(J) {
      var nonLanggananList = "div#cart-content";
      $(nonLanggananList).html($(J).filter(nonLanggananList).html());
      var drawerFooter = "div#drawer-footer"
      $(drawerFooter).html($(J).filter(drawerFooter).html());
      var countNonLangganan = $(J).filter(nonLanggananList).find('.each-cart-item').length;
      //1 <= countNonLangganan ? $('#cartAttribute .non-langganan').removeClass('dn') : $('#cartAttribute .non-langganan').addClass('dn');
    },
    error: function(J) {
      console.log(I)
    }
  }).done(function() {
    drawer.removeClass("loading")
  });
}

function updateCartPage(){
  $.ajax({
    url: "/cart?view=ajax",
    success: function(J) {
      var cart = "#cart";
      $(cart).html($(J).filter(cart).html());
    },
    error: function(J) {
      console.log(I)
    }
  }).done(function() {});
}

function updateTotalCart(){
  var parent = $("#cart_block")
  $.ajax({
    url: "/search?view=cart_total",
    success: function(J) {
      $("#cart_block p").html(($(J).filter('#total_price_ajax').html()))
    },
    error: function(J) {
      console.log(I)
    }
  }).done(function() {});
}
/*
function updateFloatingCart(price){
  if (price != 0 ) {
    $.ajax({
      url: "/search?view=cart",
      beforeSend: function() {},
      success: function(I) {
        var P = "#shopify-section-floating-bottom";
        $(P).html($(I).filter(P).html());
        $(P).fadeIn().delay(5000).fadeOut();
      },
      error: function(I) {
        console.log(I)
      }
    }).done(function() {})
  } else {
    $('#shopify-section-floating-bottom').empty();
  }
}
*/

$("#shopify-section-floating-bottom .overlay, .close-floatingCart").click(function(){
  $('#shopify-section-floating-bottom').hide();
});

quantityCounter();
quantityCounterColl();
editCart();
editCartPage()

belanjaAddToCart();
//belanjaAddToCartMobile();

drawerEditCart();


cartCheckout();